var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYtLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 30,
    viewBox: "0 0 96 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.2063 18.4373C41.032 18.4373 39.9479 17.5803 39.9479 15.9376C39.9479 14.277 41.032 13.4378 42.2063 13.4378C43.3807 13.4378 44.4648 14.277 44.4648 15.9376C44.4648 17.5981 43.3807 18.4373 42.2063 18.4373ZM42.2063 11.2773C39.5504 11.2773 37.5449 13.2236 37.5449 15.9376C37.5449 18.6338 39.5504 20.5978 42.2063 20.5978C44.8622 20.5978 46.8677 18.6338 46.8677 15.9376C46.8677 13.2236 44.8622 11.2773 42.2063 11.2773Z",
    fill: "#1E2841"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3665 20.3278H56.6611C56.625 20.0243 56.5707 19.4171 56.5707 18.7387V11.543H54.1678V16.6496C54.1678 17.6673 53.5535 18.3816 52.4875 18.3816C51.3674 18.3816 50.8614 17.5959 50.8614 16.6139V11.543H48.4585V17.096C48.4585 19.0065 49.6871 20.5599 51.8371 20.5599C52.7766 20.5599 53.8065 20.2028 54.2942 19.3814C54.2942 19.7386 54.3304 20.1493 54.3665 20.3278Z",
    fill: "#1E2841"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9179 8.91797H59.7493V10.15C59.7493 10.9356 59.3159 11.5427 58.3765 11.5427H57.9248V13.6497H59.5326V17.7386C59.5326 19.4348 60.6169 20.4526 62.3513 20.4526C63.0557 20.4526 63.4898 20.3276 63.7065 20.2383V18.2742C63.5799 18.3099 63.2548 18.3456 62.9656 18.3456C62.2789 18.3456 61.9179 18.0956 61.9179 17.3279V13.6497H63.7065V11.5427H61.9179V8.91797Z",
    fill: "#1E2841"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9698 20.3278V11.543H65.5669V20.3278H67.9698Z",
    fill: "#1E2841"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7643 20.3296V7.40234H70.3613V20.3296H72.7643Z",
    fill: "#1E2841"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5597 20.3278V11.543H75.1567V20.3278H77.5597Z",
    fill: "#1E2841"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9145 8.91797H80.7466V10.15C80.7466 10.9356 80.3125 11.5427 79.3731 11.5427H78.9214V13.6497H80.5298V17.7386C80.5298 19.4348 81.6135 20.4526 83.348 20.4526C84.053 20.4526 84.4864 20.3276 84.7032 20.2383V18.2742C84.5766 18.3099 84.2515 18.3456 83.9623 18.3456C83.2755 18.3456 82.9145 18.0956 82.9145 17.3279V13.6497H84.7032V11.5427H82.9145V8.91797Z",
    fill: "#1E2841"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8297 23.7917L95.4124 11.543H92.8469L90.6607 16.6853L88.2937 11.543H85.6016L89.378 19.2207L87.2819 23.7917H89.8297Z",
    fill: "#1E2841"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1184 15.0105V20.3313H34.6118V15.0105L39.1286 7.67188H36.3282L33.4554 12.6892L30.5827 7.67188H27.6558L32.1184 15.0105Z",
    fill: "#1E2841"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7596 10.1705C65.9463 10.1705 65.2778 9.50983 65.2778 8.72419C65.2778 7.90283 65.9463 7.24219 66.7596 7.24219C67.5907 7.24219 68.2409 7.90283 68.2409 8.72419C68.2409 9.50983 67.5907 10.1705 66.7596 10.1705Z",
    fill: "#1E2841"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3489 10.1705C75.5361 10.1705 74.8677 9.50983 74.8677 8.72419C74.8677 7.90283 75.5361 7.24219 76.3489 7.24219C77.1805 7.24219 77.8307 7.90283 77.8307 8.72419C77.8307 9.50983 77.1805 10.1705 76.3489 10.1705Z",
    fill: "#1E2841"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.139465 17.6023L14.1049 0.23422C14.5028 -0.260606 15.2956 0.0892661 15.203 0.718859L12.6502 18.0869C12.6052 18.3936 12.3435 18.6207 12.0354 18.6207H0.622687C0.0999846 18.6207 -0.18926 18.0111 0.139465 17.6023Z",
    fill: "url(#paint0_linear_1_22)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0588 12.3988L10.0871 29.7667C9.68947 30.2609 8.90116 29.9076 8.99615 29.2777L11.6156 11.91C11.6617 11.6046 11.9213 11.3789 12.2269 11.3789H23.5792C24.1001 11.3789 24.3875 11.9903 24.0588 12.3988Z",
    fill: "url(#paint1_linear_1_22)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_22",
    x1: 10.025,
    y1: -0.517242,
    x2: -0.125285,
    y2: 18.4804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC0196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#F80398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#EB0A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#D714A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#BA23B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#9437BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#674ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5856D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_22",
    x1: 10.3595,
    y1: 28.9911,
    x2: 19.9968,
    y2: 10.2942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59C7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#59C2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#59B4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#599CED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#587AE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5856D6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtLogo);
export default __webpack_public_path__ + "static/media/yt-logo.2823d115.svg";
export { ForwardRef as ReactComponent };